var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":12}},_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"position":m.position,"clickable":true,"draggable":true},on:{"click":function($event){_vm.center=m.position}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }